import { c as _c } from "react/compiler-runtime";
import { FileSourceEnum } from '@systemeio/file-manager';
import { advancedTextEditorExtensions, EditorExtensionEnum, TipTapEditor, TipTapEditorProps } from '@systemeio/tip-tap';
import { getUrlSchemeOptions, useTranslation } from '@systemeio/ui';
import { STORE_TOOLBAR_ID } from 'pages/stores/[storeId]';
import { FC } from 'react';
import { FieldErrorAndDescription } from 'shared/components/form/field-error-and-description';
import { FieldLabel } from 'shared/components/form/field-label';
import useMediaQuery from 'shared/hooks/use-media-query';
import { getSSRDocument } from 'shared/utils/get-ssr-document';
type Props = {
  label?: string;
  required?: boolean;
  content: string;
  error?: string;
  statusIcon?: React.ReactNode;
} & TipTapEditorProps;
export const StoreTextEditor: FC<Props> = t0 => {
  const $ = _c(40);
  let content;
  let error;
  let label;
  let required;
  let rest;
  let statusIcon;
  if ($[0] !== t0) {
    ({
      label,
      required,
      content,
      error,
      statusIcon,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = content;
    $[2] = error;
    $[3] = label;
    $[4] = required;
    $[5] = rest;
    $[6] = statusIcon;
  } else {
    content = $[1];
    error = $[2];
    label = $[3];
    required = $[4];
    rest = $[5];
    statusIcon = $[6];
  }
  const {
    t: tUi
  } = useTranslation();
  let t1;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getSSRDocument()?.getElementById(STORE_TOOLBAR_ID)?.clientHeight ?? 0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const storeToolbarHeight = t1;
  const {
    isLG
  } = useMediaQuery();
  const t2 = isLG ? "0" : `${storeToolbarHeight}px`;
  let t3;
  if ($[8] !== t2) {
    t3 = {
      top: t2
    };
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const toolbarStyles = t3;
  let t4;
  if ($[10] !== label || $[11] !== required) {
    t4 = <FieldLabel label={label} required={required} />;
    $[10] = label;
    $[11] = required;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== statusIcon) {
    t5 = statusIcon && <div className="absolute right-2 top-16 z-20 rounded-lg bg-white p-2 shadow-lg">{statusIcon}</div>;
    $[13] = statusIcon;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== tUi) {
    t6 = getUrlSchemeOptions(tUi);
    $[15] = tUi;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t6) {
    t7 = {
      schemeOptions: t6,
      fileSource: FileSourceEnum.DigitalStore
    };
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== tUi) {
    t8 = getUrlSchemeOptions(tUi);
    $[19] = tUi;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t8) {
    t9 = {
      schemeOptions: t8,
      fileSource: FileSourceEnum.DigitalStore
    };
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t7 || $[24] !== t9) {
    t10 = {
      [EditorExtensionEnum.Image]: t7,
      [EditorExtensionEnum.Link]: t9
    };
    $[23] = t7;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== content || $[27] !== rest || $[28] !== t10 || $[29] !== toolbarStyles) {
    t11 = <TipTapEditor extensions={advancedTextEditorExtensions} content={content} toolbarStyles={toolbarStyles} extensionOptions={t10} {...rest} />;
    $[26] = content;
    $[27] = rest;
    $[28] = t10;
    $[29] = toolbarStyles;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t11 || $[32] !== t5) {
    t12 = <div className="relative">{t5}{t11}</div>;
    $[31] = t11;
    $[32] = t5;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== error) {
    t13 = <FieldErrorAndDescription error={error} />;
    $[34] = error;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== t12 || $[37] !== t13 || $[38] !== t4) {
    t14 = <div className="flex flex-col gap-1">{t4}{t12}{t13}</div>;
    $[36] = t12;
    $[37] = t13;
    $[38] = t4;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  return t14;
};